export default [
  { value: 'onetothree', label: '1 a 3 meses' },
  { value: 'threetosix', label: '3 a 6 meses' },
  { value: 'sixtotwelve', label: '6 a 12 meses' },
  { value: 'twelveplus', label: 'Más de 12 meses' },
];



// WEBPACK FOOTER //
// ./src/utils/selectors/RoyaltyLengthOptions.js